// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"de98b77b","703":"c7d86bbf"}[chunkId] + ".chunk.js";
};